import { Injectable } from "@angular/core";
import { CheckRegisterRequest, CheckRegisterResponse, ConfirmRegisterUserPayload, ConfirmRegisterUserResponse, MyVehicleAllForChange, MyVehicleAllResponse, RegisterUserPayload, RegisterUserResponse, VehicleData } from "../../../models/user.model";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { ConfigService } from "../../config.service";
import { ApiMethodService } from "../../../../tools/services/api/method-api/apiMethod.service";
import { Observable } from "rxjs";
import { environment } from '../../../../../environments/environment';
import { InformationResponse, InsertLicensePayload, InsertLicenseResponse, MyVehicleResponse, UpdateLicensePayload } from "../../../models/information.model";
import { MyVehicleSelectPayload } from "../../../models/my-member-card/my-vehicle-select.model";

@Injectable({
    providedIn: 'root',
})

export class ApiVehicleService {
    private tokenUrl = `${environment.apiPrivateUrl}`;

    constructor(
        private http: HttpClient,
        private configService: ConfigService,
        private apiMethods: ApiMethodService,
    ) { }

    getMyVehicle(token: string, uid: string): Observable<MyVehicleResponse[]> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        const url = this.tokenUrl + `/Cityparking/Get-MyVehicle?uid=${uid}`;
        return this.http.get<MyVehicleResponse[]>(url, { headers });
    }
    getCarDetail(token: string): Observable<InformationResponse> {
        return this.http.get<InformationResponse>(
            this.tokenUrl + '/Cityparking/GetCarDetail',
        );
    }

    getUserVehicleById(
        token: string,
        uid: string,
        id: number,
    ): Observable<VehicleData> {
        const url = `${this.tokenUrl}/Cityparking/GetUserVehicleById`;
        const headers = {
            'Content-Type': 'application/json',
        };
        const params = { uid, vehicle_id: id.toString() };
        console.log("Url for GetUserVehicleById : ", this.tokenUrl + '/Cityparking/GetUserVehicleById', headers, params, JSON.stringify(params, null, 2));
        return this.http.get<VehicleData>(url, { headers, params });
    }


    updateCityVehicle(
        data: UpdateLicensePayload,
        token: string,
    ): Observable<InsertLicenseResponse> {
        const body = data;
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });
        console.log("Payload for updateCityVehicle : ", this.tokenUrl + '/Cityparking/UpdateCityVehicle ', headers, body, JSON.stringify(body, null, 2));
        return this.http.post<InsertLicenseResponse>(
            this.tokenUrl + '/Cityparking/UpdateCityVehicle ',
            body,
            {
                headers,
            },
        );
    }

    getVehicleUserAllBySite(
        token: string,
        uid: string,
        siteId: number,
        anotherParam?: string,
    ): Observable<MyVehicleAllResponse[]> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });

        // 👉 ใช้ HttpParams สำหรับจัดการ query string
        let params = new HttpParams()
            .set('uid', uid)
            .set('siteId', siteId.toString());

        if (anotherParam) {
            params = params.set('anotherParam', anotherParam);
        }
        const url = `${this.tokenUrl}/Cityparking/GetUserVehicleSite`;
        return this.http.get<MyVehicleAllResponse[]>(url, { headers, params });
    }

    getVehicleMemberInfo(
        token: string,
        uid: string,
        siteId: number,
        cardCode: string,
    ): Observable<MyVehicleAllResponse[]> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });

        // 👉 ใช้ HttpParams สำหรับจัดการ query string
        let params = new HttpParams()
            .set('Uid', uid)
            .set('SiteId', siteId.toString())
            .set('CardCOde', cardCode);
        const url = `${this.tokenUrl}/Cityparking/GetVehicleMemberInfo`;
        return this.http.get<MyVehicleAllResponse[]>(url, { headers, params });
    }

    getVehicleAllChangeMember(
        // token: string,
        // uid: string,
        // site_id: number,
        // cardcode: string,
        // vehicle_type: number,
        body: MyVehicleSelectPayload
    ): Observable<MyVehicleAllForChange[]> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
        });

        const params = new HttpParams()
            .set('Uid', body.uid)
            .set('SiteId', body.siteId?.toString() || '')
            .set('CardCode', body.cardCode || '')
            .set('VehicleTypeId', body.vehicleTypeId?.toString() || '');
        return this.http.get<MyVehicleAllForChange[]>(
            this.tokenUrl + '/Cityparking/GetVehicleAllChangeMember',
            { headers, params },
        );
    }



}